import { api } from 'modules/api';
import { getIpfsImage } from 'modules/api/methods/getIpfsImage';
import { getIPFSHash } from 'modules/pool/utils';

export interface IGetIpfsImageParams {
  // The IPFS link to the image file, e.g., "ipfs://Qm..."
  ipfsLink: string;
}

export const { useGetIpfsImageQuery } = api.injectEndpoints({
  endpoints: build => ({
    getIpfsImage: build.query<string, IGetIpfsImageParams>({
      queryFn: async ({ ipfsLink }) => {
        if (!ipfsLink) {
          return { data: '' };
        }

        const hash = getIPFSHash(ipfsLink);
        const blobData = await getIpfsImage(hash);

        return {
          data: URL.createObjectURL(blobData),
        };
      },
    }),
  }),
});
